import axios from 'axios' // 注意先安装哦
import config from './config.js' // 倒入默认配置
import Cookies from 'js-cookie'
import router from '@/router'
import { Toast } from 'vant';

export default function $axios(options) {
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      baseURL: config.baseURL,
      headers: config.headers,
    }
    )
    // request 拦截器
    instance.interceptors.request.use(config => {
      const adminToken = Cookies.get('admin_token')
      if (adminToken) {
        config.headers['Authorization'] = encodeURIComponent(adminToken)
      }
      return config
    }, err => {
      return Promise.resolve(err);
    })

    // response 拦截器
    instance.interceptors.response.use(
      response => {
        let data;
        // Toast.fail(3333);
        if (response.data == undefined) {
          data = response.request.responseText
        } else {
          data = response.data
        }
        if (!data.success) {
          Toast.fail(data.i18nMessage);
        }
        return data
      },
      err => {
        if (err.response.status === 401) {
          // Cookies.remove('lark_token')
          // router.replace({
          //   path: '/login',
          //   query: { redirect: router.currentRoute.fullPath }
          // });
        }
        return Promise.reject(err) // 返回接口返回的错误信息
      }
    )

    // 请求处理
    instance(options)
      .then((res) => {
        resolve(res)
        return false
      })
      .catch((error) => {
        reject(error)
      })
  })
}
